const BOOT_LOADING_LABEL_SESSION_KEY = 'buxus-boot-loading-label'

/** One-shot label for the next full-page boot spinner (survives OIDC logout redirect). */
export function setBootLoadingLabel(label: string): void {
  try {
    sessionStorage.setItem(BOOT_LOADING_LABEL_SESSION_KEY, label)
  } catch {
    /* private mode / quota */
  }
}

/** Read and clear the boot label set before a redirect (e.g. logout). */
export function takeBootLoadingLabel(): string | undefined {
  try {
    const v = sessionStorage.getItem(BOOT_LOADING_LABEL_SESSION_KEY)
    if (v) sessionStorage.removeItem(BOOT_LOADING_LABEL_SESSION_KEY)
    return v ?? undefined
  } catch {
    return undefined
  }
}
